import { makeStyles } from "@material-ui/core/styles";
import React, { useEffect, useState } from "react";
import Papa from "papaparse";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import LandscapingRoute from "./landscaping/landscaping-route";
import { Divider } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { MdStar } from "react-icons/md";

const useStyles = makeStyles(() => ({
  routeBlock: {
    width: "65%",
    marginBottom: "10px",
    float: "left",
  },
  greenTextBox: {
    display: "inline-block",
    backgroundColor: "#00C23C",
    color: "white",
    borderRadius: "10px",
    fontSize: "16px",
    fontWeight: "500",
    fontFamily: "Poppins",
    paddingLeft: "10px",
    paddingRight: "10px",
    paddingTop: "5px",
    paddingBottom: "5px",
  },
  topRow: {
    marginLeft: "15px",
  },
  routeHeader: {
    marginTop: "0px",
    marginBottom: "0px",
    fontWeight: "700",
    letterSpacing: "-1px",
  },
  completedBlock: {
    marginTop: "0px",
    marginBottom: "0px",
    fontWeight: "400",
    fontSize: "16px",
  },
  leftBlock: {
    float: "left",
    width: "35%",
  },
  completionPercentage: {
    marginTop: "0px",
    marginBottom: "0px",
    paddingBottom: "0px",
    paddingTop: "0px",
    fontSize: "60px",
  },
  chipText: {
    fontSize: "10px",
    fontWeight: "400",
    fontFamily: "Poppins",
  },
}));

function CleanupsPage(props) {
  const classes = useStyles();
  const [data, setData] = useState([]);
  const [addressCache, setAddressCache] = useState({});
  const navigate = useNavigate();

  async function getData() {
    try {
      const url = `https://script.google.com/macros/s/${props.script_id}/exec?method=getData&driver=${encodeURIComponent(props.id)}`;
      const res = await fetch(url, { method: "GET" });
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      const json = await res.json();
      setData(Array.isArray(json) ? json : []);
    } catch (err) {
      console.error("Failed to load cleanups data:", err);
      setData([]);
    }
  }

  useEffect(() => {
    getData();
    document.title = props.id;
  }, []);

  const setAddress = (address) => {
    let newcache = { ...addressCache };
    newcache[address] = true;
    setAddressCache(newcache);
  };

  let routes = Array.from(data);
  routes = routes.filter(
    (route) => route.Driver.toLowerCase() === props.id.toLowerCase()
  );

  const checkCache = () => {
    for (let i = 0; i < routes.length; i++) {
      if (addressCache[routes[i].Address] !== undefined) {
        routes[i].Completed = "yes";
      }
    }
    return routes;
  };

  routes = checkCache();
  let numRoutes = routes.length;
  let completed = routes.filter((route) => route.Completed === "yes");
  let numCompleted = completed.length;
  let percentage =
    numRoutes === 0 ? 0 : Math.trunc((numCompleted / numRoutes) * 100);

  const mapsSelector = (url, address) => {
    let platform =
      navigator?.userAgentData?.platform || navigator?.platform || "unknown";
    if (
      platform.indexOf("iPhone") !== -1 ||
      platform.indexOf("iPad") !== -1 ||
      platform.indexOf("MacIntel") !== -1
    ) {
      return "https://maps.apple.com/?q=" + address.replaceAll(" ", "+");
    } else {
      return "https://maps.google.com/maps?q=" + address.replaceAll(" ", "+");
    }
  };

  const last = (array) => {
    return array[array.length - 1];
  };

  const trimAddress = (address) => {
    let trimPosition = address.search(", MA");
    return address.substring(0, trimPosition);
  };

  const stops = routes.map((r, i) => ({
    address: trimAddress(r.Address),
    cityState: r.Address.split(", ").slice(1).join(", "),
    r: r,
    bucket: r.Bucket,
    services: [
      ...(r.Cleanup !== ""
        ? [
            {
              name: "Cleanup",
              highlight: r.Cleanup === "Completed",
              icon: <MdStar />,
            },
          ]
        : []),
      ...(r.Weeding !== ""
        ? [
            {
              name: "Weeding",
              highlight: r.Weeding === "Completed",
              icon: (
                <Typography
                  fontSize="10px"
                  fontWeight="600"
                  fontFamily="Poppins"
                  color="#000"
                >
                  {r["Weeding Hours"]}
                </Typography>
              ),
            },
          ]
        : []),
      ...(r.Mulching !== ""
        ? [
            {
              name: "Mulching",
              highlight: r.Mulching === "Completed",
              color: last(r["Mulch Color"].split(" ")),
              mulch_color: r["Mulch Color"],
              icon: (
                <Typography
                  fontSize="10px"
                  fontWeight="600"
                  fontFamily="Poppins"
                  color="#fff"
                  backgroundColor="#fff"
                  borderRadius="20px"
                  paddingLeft="3px"
                  paddingRight="3px"
                >
                  {r["Mulch Yards"]}
                </Typography>
              ),
            },
          ]
        : []),
      ...(r["Bush Trimming"] !== ""
        ? [
            {
              name: "Bush Trimming",
              highlight: r["Bush Trimming"] === "Completed",
              icon: (
                <Typography
                  fontSize="10px"
                  fontWeight="600"
                  fontFamily="Poppins"
                  color="#000"
                >
                  {r["Bush Hours"]}
                </Typography>
              ),
            },
          ]
        : []),
      ...(r.Edging !== ""
        ? [
            {
              name: "Edging",
              highlight: r.Edging === "Completed",
              icon: <MdStar />,
            },
          ]
        : []),
      ...(r.Fertilizing !== ""
        ? [
            {
              name: "Fertilizing",
              highlight: r.Fertilizing === "Completed",
              icon: (
                <Typography
                  fontSize="10px"
                  fontWeight="600"
                  fontFamily="Poppins"
                  color="#000"
                >
                  {r["Fertilizer Bags"]}
                </Typography>
              ),
            },
          ]
        : []),
      ...(r.Aeration !== ""
        ? [
            {
              name: "Aeration",
              highlight: r.Aeration === "Completed",
              icon: <MdStar />,
            },
          ]
        : []),
      ...(r.Other !== ""
        ? [
            {
              name: "Other",
              highlight: r.Other === "Completed",
              icon: <MdStar />,
            },
          ]
        : []),
    ],
    completed: r.Completed === "yes",
    onMapClick: () => window.open(mapsSelector(r.Link, r.Address), "_blank"),
    onNotesClick: () => console.log("NOTES:", r.Address),
    onViewJobClick: () =>
      navigate("/view-job", {
        state: {
          stopNumber: i + 1,
          addressLong: r.Address,
          address: trimAddress(r.Address),
          cityState: r.Address.split(", ").slice(1).join(", "),
          bucket: r.Bucket || "Medium",
          r: r,
          jobs: [
            "Cleanup",
            "Weeding",
            "Mulching",
            "Bush Trimming",
            "Edging",
            "Fertilizing",
            "Aeration",
            "Other",
          ].filter((j) => r[j] !== ""),
          quotes: ["Bush trimming", "Mulching"].filter((q) => r[q] === "yes"),
          notes: r.Notes || "No notes",
          notes_spanish: r.Notes_Spanish || "",
          notes_portuguese: r.Notes_Portuguese || "",
          other_description: r["Other Description"] || "",
          image_upload_path: props.image_upload_path,
          script_id: props.script_id,
          driver: props.driver,
        },
      }),
  }));

  return (
    <div>
      {/* Header Row */}
      <div className={classes.topRow}>
        <div className={classes.routeBlock}>
          <h1 className={classes.routeHeader}>{props.id}</h1>
          <div className={classes.greenTextBox}>Special Services</div>
        </div>
        <div className={classes.leftBlock}>
          <h1 className={classes.completionPercentage}>{percentage}%</h1>
          <h3 className={classes.completedBlock}>
            {numCompleted}/{numRoutes} completed
          </h3>
        </div>
        <Box mt={2} mb={3}>
          <Divider sx={{ borderColor: "red", borderBottomWidth: "10px" }} />
        </Box>
      </div>

      {/* Render Landscaping Route */}
      <Box mt={2}>
        <LandscapingRoute stops={stops} />
      </Box>
    </div>
  );
}

export default CleanupsPage;